module.exports = __webpack_public_path__ + "img/horizontal_4_5_r_pp3_3016.0264866b.png";